import Button from "@mui/material/Button";
import { useParams } from "react-router-dom";
import { Grid, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useEffect, useState } from "react";
import { useGetOne, useNotify, useRefresh } from "react-admin";
import sendRequest from "../../dataProvider/sendRequest";
import HmPageHeaderTitle from "../../unit/HmPageHeaderTitle";
import Collections from "./transunions/Collections";
import CreditScore from "./transunions/CreditScore";
import CreditSummary from "./transunions/CreditSummary";
import Notices from "./transunions/Notices";
import PublicRecords from "./transunions/PublicRecords";
import Trade from "./transunions/Trade";
import CustomDetailBox from "../summary_tabs/CustomDetailBox";
import DisabledButtonWithTip from "../../unit/DisabledButtonWithTip";

const MainSection = styled("article")({
  paddingTop: "10px",
  paddingBottom: "48px",
  height: `calc(100vh - 120px - 60px - 110px - 55px)`,
  overflowY: "auto",
  backgroundColor: "#fff",
  maxWidth: "100%",
  autoOverflowX: "auto",
  overflowX: "hidden",

  display: "block",
  width: "calc(100vw - 155px)",
});
const TransUnionShow = ({ ...props }) => {
  const record = props.record;
  const appStatus = props.appStatus;
  const params = useParams();
  let appId = params.appId;
  let haveData = false;
  if (appId === "" || appId === undefined) {
    appId = props.appId ? props.appId : "";
  }
  if (appId === "" || appId === undefined) {
    return <Typography>Missing Id...</Typography>;
  }
  const reqUrl = `credit_report`;
  interface TuDataType {
    data: any;
  }
  const [tuData, setTuData] = useState<TuDataType | null>(null);
  const [checkDataStatus, setCheckDataStatus] = useState("");
  const { data, isPending, error } = useGetOne(reqUrl, { id: appId });
  const refresh = useRefresh();
  const notify = useNotify();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setTuData(data);
    if (data) {
      if (data?.data) {
        if (data?.data?.status == "error") {
          setCheckDataStatus("error");
        } else {
          setCheckDataStatus("");
        }
      }
    } else {
      setCheckDataStatus("error");
    }
  }, [data]);

  if (isPending) {
    return <Typography>TU Data Loading...</Typography>;
  }
  if (error) {
    return <Typography>TU Data Loading Error</Typography>;
  }

  if (!tuData) {
    return <Typography>Loading data...</Typography>;
  }
  const sourcedata = tuData?.data;

  const handelReqTuData = () => {
    const reqUrl = `credit_report/${appId}?requestTransUnionData=yes`;
    sendRequest(reqUrl, { id: appId })
      .then((response) => {
        setTuData(response);
        setCheckDataStatus("");
      })
      .catch((error) => {
        notify("Error requesting TransUnion data: " + error.message, {
          type: "warning",
        });
      });
  };

  return (
    <>
      <Grid container sx={{ p: 1 }}>
        <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
          <HmPageHeaderTitle title={"Credit Reports"} />
        </Grid>

        <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
          {tuData?.data?.pullDate && sourcedata ? (
            <Typography
              variant="h6"
              sx={{ textAlign: "right" }}
            >{`Report Generated on ${tuData?.data?.pullDate}`}</Typography>
          ) : (
            <>
              {(appStatus == "Initial Review" ||
                appStatus == "restart" ||
                appStatus == "New" ||
                appStatus == "Check" ||
                appStatus == "Final Review") && (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handelReqTuData}
                  sx={{ width: "120px", float: "right" }}
                >
                  Request
                </Button>
              )}
              {appStatus != "Initial Review" &&
                appStatus != "restart" &&
                appStatus != "New" &&
                appStatus != "Check" &&
                appStatus != "Final Review" && (
                  <>
                    <DisabledButtonWithTip
                      tip="Request cannot be performed when the application is not under review."
                      label="Request"
                    />
                  </>
                )}
            </>
          )}
        </Grid>
      </Grid>
      <MainSection
        id="mainsection-transunion"
        className="app-summary-bodysection"
      >
        {tuData && checkDataStatus != "error" ? (
          <>
            <Notices sourcedata={sourcedata} />
            <CreditScore sourcedata={sourcedata} key="creditscoreSection" />
            <CreditSummary sourcedata={sourcedata} />
            <PublicRecords sourcedata={sourcedata} />
            <Collections sourcedata={sourcedata} />
            {/* Trade Data */}
            <Trade sourcedata={sourcedata} />
          </>
        ) : null}
      </MainSection>
    </>
  );
};

export default TransUnionShow;
